module.exports = __webpack_public_path__ + "assets/img/3a33-zm.svg";